import React from "react";
import ReturnImage from "../functions/image";
import { NavLink } from "react-router-dom";

const Pagebannerintern = ({breadcrumb, title}) => {
    return(
        <div className="container">
            <div className="row">
                <div className="pagebanner-intern container-fluid text-white pt-4 pb-4 pt-lg-5 pb-lg-5 col-12">
                    <div className="pagebanner-intern-container d-flex flex-column">
                        <div className="pagebanner-intern-breadcrumb d-flex">
                            <span>
                                <NavLink to="/">Accueil</NavLink>
                            </span>
                            <span>
                                {breadcrumb}
                            </span>
                        </div>
                        <div className="pagebanner-intern-title mt-3 mt-lg-4">
                            <h1 className="pagebanner-intern-title-animate mb-3 mb-sm-0">{title}</h1>
                        </div>
                        <ReturnImage
                         imageName="codage-paysage"
                         classname="pagebanner-intern-image"
                         alt="Développez vos projets avec Mustafa Ekiz"
                         viewport={100} />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Pagebannerintern;